export default __webpack_public_path__ + "static/media/036-Card game.98026823.svg";